import { FileImagePlusOutlineIcon } from './FileImagePlusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 0D25D768-827E-4FE8-9A45-67D883E3B6FA
 * name file-image-plus-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-image-plus-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileImageAddOutlineIcon = FileImagePlusOutlineIcon;
export default FileImageAddOutlineIcon